import React, { useEffect, useState } from "react";
import Popup from "reactjs-popup";
import { FaEdit, FaPlus, FaTrash } from "react-icons/fa";
import { TextInput } from "./TextInput";
import axios from "axios";

function ModalArray({ value = [], onSubmit, label, dbId }) {
  const [open, setOpen] = useState(false);
  const [content, setContent] = useState([]);

  useEffect(() => {
    setContent(value);
  }, [value]);

  const onClick = () => setOpen(!open);

  const add = (newItem) => {
    setContent([...content, newItem]);
  };

  const remove = async (index) => {
    const confirm = window.confirm("Are you sure you want to delete this item?");
    if (!confirm) return;

    try {
      const res = await axios.delete(`/api/homepage/news/${dbId}/${index}`);
      if (res.data && res.data.news) {
        setContent(res.data.news); // update from DB
      }
    } catch (err) {
      console.error("Error deleting news:", err);
      alert("Failed to delete news item");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = new FormData(e.currentTarget);
    const updatedArray = content.map((_, id) => data.get(label + id));
    setContent(updatedArray);
    await onSubmit(updatedArray);
    setOpen(false);
  };

  return (
    <div className="modalDiv">
      <FaEdit onClick={onClick} />

      <Popup className="editModal" open={open} closeOnDocumentClick={false}>
        <a className="close" onClick={onClick}>
          &times;
        </a>
        <p>Edit</p>

        <div style={{ maxHeight: '55vh', overflowY: 'auto' }}>
          <form onSubmit={handleSubmit}>
            {content.map((item, id) => (
              <div key={id} style={{ display: 'flex', alignItems: 'center', marginBottom: '0.5rem' }}>
                <TextInput id={id} text={item} label={label} />
                <FaTrash
                  onClick={() => remove(id)}
                  style={{ marginLeft: '10px', cursor: 'pointer', color: 'red' }}
                />
              </div>
            ))}
            <div style={{ marginTop: '1rem' }}>
              <FaPlus onClick={() => add("New")} style={{ cursor: 'pointer', marginRight: '10px' }} />
              <button type="submit">Submit</button>
            </div>
          </form>
        </div>
      </Popup>
    </div>
  );
}

export default ModalArray;
